export const States = {
	NODATA: 0x1,
	NOFACE: 0x10,
	TWOFACE: 0x100,
	TOOFAR: 0x1000,
	TOONEAR: 0x10000,
	NOTSTRAIGHT: 0x100000,
}

export const LoginStates = {
	IDLE: 0,
	SUCCESS: 1,
	COUNTING: 2,
	NOT_READY: -1,
	ERROR: -2
}

export const StateMessages = {};
StateMessages[States.NODATA] = 'Loading...'
StateMessages[States.NOFACE] = 'No faces detected.'
StateMessages[States.TWOFACE] = 'Please exclude other faces from the frame.'
StateMessages[States.TOOFAR] = 'Please come closer to the camera.'
StateMessages[States.TOONEAR] = 'Please lean away from the camera.'
StateMessages[States.NOTSTRAIGHT] = 'Look straight into the camera, please.'

function unlerp(min, max, value) {
  return (value - min) / (max - min)
}
function unlerp2d(r, ref) {
  return {
  	_x: unlerp(0, ref.width, r._x),
  	_y: unlerp(0, ref.height, r._y)
  }
}

export const resultsMap = {
	1: "All checks passed!",
	2: "Passport / ID information is incorrect.",
	3: "Liveness check failed.",
	4: "Could not recognize the face.",
	5: "The external ID service did not respond.",
	6: "The user in the request is marked as deceased.",
	7: "The external ID service failed to provide the original photo.",
	8: "MyID environment is improperly configured; please contact support.",
	9: "The request took too long to execute.",
	10: "The task took too long in the processing queue.",
	11: "The MyID service could not process the request. Please try again later.",
	12: "The MyID service could not process the request. Please try again later.",
	13: "The MyID service could not process the request. Please try again later.",
	14: "Could not recognize the face.",
	15: "The MyID service could not process the request. Please try again later.",
	16: "The MyID service could not process the request. Please try again later.",
	17: "Could not recognize the face.",
	18: "The MyID Liveness service could not process the request. Please try again later.",
	19: "The MyID Comparison service could not process the request. Please try again later.",
	20: "The image is too blurry or low-quality.",
	21: "The face is not fully visible.",
	22: "Multiple faces detected in the image.",
	23: "The provided image is grayscale, please capture a color image.",
	24: "Eyes are obstructed; please take off sunglasses.",
	25: "The image type is not supported.",
	26: "Could not detect eyes or eyes are closed.",
	27: "Please face straight; face rotation detected."
}

export const Validators = {
	position: (r, ref) => {
		let rCenter = r.alignedRect._box._x + r.alignedRect._box._width / 2;
		let refCenter = ref.width / 2;
		let rCenterY = r.alignedRect._box._y + r.alignedRect._box._height / 2;
		let refCenterY = ref.height / 2;
		if(Math.abs(rCenter - refCenter) > ref.height / 10) return -1;
		if(Math.abs(rCenterY - refCenterY) > ref.height / 10) return -1;
		return 0;
	},
	size: (r, ref) => {
		if(r.alignedRect._box._height / ref.height < 0.4) return -1; //far
		if(r.alignedRect._box._height / ref.height > 0.7) return 1; //near
		return 0;
	},
	pan: (r, ref) => {
		const EAR_L = unlerp2d(r.landmarks._positions[0], ref)
		const EAR_R = unlerp2d(r.landmarks._positions[16], ref)
		const NOSE = unlerp2d(r.landmarks._positions[30], ref)
		const threshold = 0.1;
		if(unlerp(EAR_L._x, EAR_R._x, NOSE._x) > 0.5 + threshold) return 1 //right pan
		if(unlerp(EAR_L._x, EAR_R._x, NOSE._x) < 0.5 - threshold) return -1 //left pan
		return 0;
	}
}




export function traverseUp(elem,classname,max,exclude){
var i;
	if(typeof max == 'undefined') max = 10;
	exclude === undefined?'lelell':exclude;
	for(i=0;i<max;i++){
		if(elem.classList.contains(exclude) || elem.tagName == 'HTML') return null;
		if(elem.classList.contains(classname) || elem === classname){
			return elem;
		}else{
			try{
				elem = elem.parentNode;
				if(typeof elem === undefined || elem == null) return null;
			}catch(e){
				return null;
			}
		}
	}
	return null;
}
